import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, Col, Row } from 'react-bootstrap';
import SiteCard from '../components/SiteCard';
import SEOComponent from '../components/SEOComponent';
import HomeLookupDemo from '../components/HomeLookupDemo';
import { FaChartLine, FaMapMarkedAlt, FaRobot } from 'react-icons/fa';
// import {AdComponent} from '../components/AdComponent';

import './Home.css';

const Home = () => {
    const rowRefs = useRef([]);
    const [isHovering, setIsHovering] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            rowRefs.current.forEach((row, index) => {
                if (row) {
                    const rect = row.getBoundingClientRect();
                    const isVisible = rect.top < window.innerHeight && rect.bottom >= 0;
                    row.style.opacity = isVisible ? '1' : '0.5';
                    row.style.transform = isVisible ? 'scale(1)' : 'scale(0.98)';
                    row.style.transitionDelay = `${index * 0.1}s`;
                }
            });
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <>
            <SEOComponent 
                title="Otta Property - UK's First Machine Learning Property Index & AI Price Predictor" 
                description="Beat the property market with Data Science. Access the UK's first machine learning property index, interactive maps, and AI-powered price predictions for England and Wales properties. Get free access to cutting-edge property data analytics." 
                url="https://ottaproperty.co.uk/" 
                image="https://ottaproperty.co.uk/otta_logo2.png" 
            />

            <header>
                <Container
                    fluid
                    className="hero-section d-flex align-items-center justify-content-center px-4"
                    style={{
                        minHeight: '60vh',
                        backgroundColor: 'rgba(0, 0, 0, 0.7)'
                    }}
                >
                    {/* <Row className="justify-content-center w-100"> */}
                        <Col xs={12} md={8} lg={6} className="text-center">
                            <h1 className="display-4 text-white mb-4">
                                PROPERTY DATA SCIENCE MADE EASY
                            </h1>
                            <p className="lead text-white mb-5">
                                Compare property prices and trends in England and Wales with our free tools.
                                Subscribe for unlimited predictions and advanced map features.
                            </p>
                        <Link to="/trends">
                            <button className="btn btn-light btn-lg" style={{ margin: '0.5rem' }}>
                                Explore Property Trends
                            </button>
                        </Link>

                        <Link to="/map">
                            <button className="btn btn-light btn-lg" style={{ margin: '0.5rem' }}>
                                Explore the Map
                            </button>
                        </Link>
                        </Col>
                    {/* </Row> */}
                </Container>
            </header>

            {/* Try-it-first Rightmove lookup: let visitors feel the value before signing up */}
            <HomeLookupDemo />

      {/* <AdComponent /> */}


            <section aria-labelledby="map-section">
                <Container className="d-flex flex-column align-items-center">
                <Row 
                        ref={(el) => rowRefs.current[0] = el}
                        className="justify-content-center transition-row my-5 mx-0" 
                        style={{ width: '100%'}}
                    >
                        <Col md={12}>
                            <SiteCard 
                                header={<><FaMapMarkedAlt className="mr-2" /> MAP</>}
                            content={
                                <Container fluid className="h-100">
                                    <Row className="h-100 align-items-center" style={{ minHeight: '40vh' }}>
                                        <Col md={6} className="d-flex flex-column justify-content-center">
                                        <h2 id="map-section" className="text-center" style={{ marginBottom: '1rem', marginTop: '1rem' }}>
                                        Interactive Property Map</h2>
                                            <p>Explore our interactive map showcasing property data across England and Wales. Filter by property type, date, and price to visualise market trends in different areas.</p>
                                            <p><em>Free users can explore regional views. Subscribe for full zoom access to street and postcode-level detail.</em></p>
                                            <div className="text-center" style={{ marginTop: '1rem' , marginBottom: '1rem'}}>
                                                <Link to="/map">
                                                    <button className="otta-button mt-3">
                                                        View Interactive Map
                                                    </button>
                                                </Link>
                                            </div>
                                        </Col>
                                        <Col md={6} className="d-flex align-items-center justify-content-center">
                                            <img src="/map.webp" alt="Interactive Property Map showing England and Wales property data visualization" className="img-fluid rounded shadow site-card-image" loading="lazy" />
                                        </Col>
                                    </Row>
                                </Container>
                            }
                        />
                        </Col>
                    </Row>
                </Container>
            </section>


            {/* <AdComponent /> */}
            <Container className="d-flex flex-column align-items-center">



                
            <Row 
                ref={(el) => rowRefs.current[2] = el}
                className="justify-content-center transition-row my-5 mx-0"  
                style={{ width: '100%' }}
            >
                <Col md={12}>
                    <SiteCard 
                        header={<><FaRobot className="mr-2" /> REVOLUTIONARY ML PREDICTION TOOL</>}
                        content={
                            <Container fluid className="h-100">
                                <Row className="h-100 align-items-center" style={{ minHeight: '40vh' }}>
                                    <Col md={6} className="d-flex flex-column justify-content-center">
                                        <h3 className="text-center" style={{ marginBottom: '1rem', marginTop: '1rem' }}>
                                            Machine Learning Property Price Predictor
                                        </h3>
                                        <p>
                                            <strong>Groundbreaking Technology:</strong> The market's first-ever machine learning tool for property prediction.
                                        </p>
                                        <p>
                                            Harness the power of advanced algorithms to:
                                        </p>
                                        <ul>
                                            <li>Predict property values with unprecedented accuracy</li>
                                            <li>Make data-driven investment decisions</li>
                                            <li>Download and export prediction history (subscribers)</li>
                                        </ul>
                                        <p>
                                            <em>Try 3 predictions for free daily, or subscribe for unlimited access.</em>
                                        </p>
                                        <div className="text-center">
                                            <Link to="/machine-learning-property-price-predictor">
                                                <button className="otta-button mt-3">
                                                    Try it for Free Now!
                                                </button>
                                            </Link>
                                        </div>
                                    </Col>
                                    <Col md={6} className="d-flex align-items-center justify-content-center">
                                        <img src="/predictor.webp" alt="Machine Learning Property Price Predictor showing AI-powered property valuation interface" className="img-fluid rounded shadow site-card-image" loading="lazy" />
                                    </Col>
                                </Row>
                            </Container>
                        }
                    />
                </Col>
            </Row>

            </Container>


            {/* <AdComponent /> */}
            
            <Container className="d-flex flex-column align-items-center">


            <Row 
                    ref={(el) => rowRefs.current[1] = el}
                    className="justify-content-center transition-row my-5 mx-0" 
                    style={{ width: '100%'}}
                >
                    <Col md={12}>
                        <SiteCard 
                            header={<><FaChartLine className="mr-2" /> TRENDS</>}
                            content={
                                <Container fluid className="h-100">
                                    <Row className="h-100 align-items-center" style={{ minHeight: '40vh' }}>
                                        <Col md={6} className="d-flex align-items-center justify-content-center">
                                            <img src="/trend.webp" alt="Property Trends Chart showing machine learning based property index data for UK market analysis" className="img-fluid rounded shadow site-card-image" loading="lazy" />
                                        </Col>
                                        <Col md={6} className="d-flex flex-column justify-content-center">

                                            <h3 className="text-center" style={{ marginBottom: '1rem', marginTop: '1rem' }}>
                                                The First Ever ML based Property Index
                                            </h3>
                                            <p>Stay ahead of the market with our comprehensive trend analysis. Get insights into price movements, market hotspots, and emerging patterns in the property landscape.
                                                Made possible by our cutting-edge machine learning algorithms, our trend analysis tool is the first of its kind in the market.</p>
                                            <p><em>Access to ML Index and Raw Data is completely free for all users.</em></p>
                                            <div className="text-center" style={{ marginTop: '1rem' , marginBottom: '1rem'}}>
                                                <Link to="/trends">
                                                    <button className="otta-button mt-3">
                                                        Explore Trends
                                                    </button>
                                                </Link>
                                            </div>
                                        </Col>
                                    </Row>
                                </Container>
                            }
                        />
                    </Col>
                </Row>  
                
                       
            
            
          
                

               
            </Container>

            {/* <AdComponent /> */}


            <Container fluid className="cta-section py-5 text-white text-center">
                <h2 className="mb-4">Ready to gain the edge in property market?</h2>
                <Link to="/members">
                    <button
                        className="btn btn-light btn-lg"
                        onMouseEnter={() => setIsHovering(true)}
                        onMouseLeave={() => setIsHovering(false)}
                    >
                        Get Started Now
                        <span className={`ml-2 ${isHovering ? 'animate__animated animate__headShake' : ''}`}>
                            →
                        </span>
                    </button>
                </Link>
            </Container>

            {/* FAQ Section */}
            <Container className="d-flex flex-column align-items-center">
                <Row className="justify-content-center my-5 mx-0" style={{ width: '100%' }}>
                    <Col md={12}>
                        <SiteCard
                            header="FAQ"
                            content={
                                <div className="faq-list">
                                    <div className="faq-item">
                                        <h3 className="faq-question">What is Otta Property?</h3>
                                        <p>Otta Property is the UK's most advanced AI-powered property analytics platform. It is the first website to apply machine learning to build a property price index for England and Wales, offering interactive maps, AI price predictions, and comprehensive market trend analysis - all powered by Land Registry and EPC data.</p>
                                    </div>
                                    <div className="faq-item">
                                        <h3 className="faq-question">How does the machine learning property price predictor work?</h3>
                                        <p>Our price predictor uses advanced machine learning models trained on millions of Land Registry transactions and Energy Performance Certificate (EPC) data. Enter a postcode and property details to get an AI-generated price estimate with confidence intervals and comparable recent sales.</p>
                                    </div>
                                    <div className="faq-item">
                                        <h3 className="faq-question">Is Otta Property free to use?</h3>
                                        <p>Yes - the ML property index, trend analysis, and regional map views are completely free. You also get 3 free AI price predictions per day. Subscribers unlock unlimited predictions, full street-level map zoom, and data export features.</p>
                                    </div>
                                    <div className="faq-item">
                                        <h3 className="faq-question">What data does Otta Property use?</h3>
                                        <p>We use official UK Land Registry Price Paid data (updated monthly) covering every recorded property sale in England and Wales, combined with Energy Performance Certificate (EPC) data which provides floor area measurements for price-per-square-metre calculations.</p>
                                    </div>
                                    <div className="faq-item">
                                        <h3 className="faq-question">How is Otta Property different from Rightmove or Zoopla?</h3>
                                        <p>Unlike traditional property portals that list properties for sale, Otta Property is a data science platform. We apply machine learning and AI directly to transaction data to generate insights, predictions, and indices that aren't available anywhere else. We focus on analytics and market intelligence rather than property listings.</p>
                                    </div>
                                </div>
                            }
                        />
                    </Col>
                </Row>
            </Container>

            {/* FAQ Structured Data for Google Rich Results */}
            <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
                "@context": "https://schema.org",
                "@type": "FAQPage",
                "mainEntity": [
                    {
                        "@type": "Question",
                        "name": "What is Otta Property?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Otta Property is the UK's most advanced AI-powered property analytics platform. It is the first website to apply machine learning to build a property price index for England and Wales, offering interactive maps, AI price predictions, and comprehensive market trend analysis - all powered by Land Registry and EPC data."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "How does the machine learning property price predictor work?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Our price predictor uses advanced machine learning models trained on millions of Land Registry transactions and Energy Performance Certificate (EPC) data. Enter a postcode and property details to get an AI-generated price estimate with confidence intervals and comparable recent sales."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Is Otta Property free to use?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Yes - the ML property index, trend analysis, and regional map views are completely free. You also get 3 free AI price predictions per day. Subscribers unlock unlimited predictions, full street-level map zoom, and data export features."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "What data does Otta Property use?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "We use official UK Land Registry Price Paid data (updated monthly) covering every recorded property sale in England and Wales, combined with Energy Performance Certificate (EPC) data which provides floor area measurements for price-per-square-metre calculations."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "How is Otta Property different from Rightmove or Zoopla?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Unlike traditional property portals that list properties for sale, Otta Property is a data science platform. We apply machine learning and AI directly to transaction data to generate insights, predictions, and indices that aren't available anywhere else. We focus on analytics and market intelligence rather than property listings."
                        }
                    }
                ]
            })}} />

        </>
    );
}

export default Home;